export default __webpack_public_path__ + "static/media/twitter.c38ce72d.svg";